import { render, staticRenderFns } from "./PublishingFundsPg.vue?vue&type=template&id=5d29a616&scoped=true&"
import script from "./PublishingFundsPg.vue?vue&type=script&lang=js&"
export * from "./PublishingFundsPg.vue?vue&type=script&lang=js&"
import style0 from "./PublishingFundsPg.vue?vue&type=style&index=0&id=5d29a616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d29a616",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
